


































































































import Component, { mixins } from 'vue-class-component';
import { loadView, loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { ICallbackBody, IMerchants, IPaginate, IPaymentCallback } from '@/types/types';
import timestamp from '@/filters/timestamp';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import DialogMixins from '@/mixins/DialogMixins';
import qs from 'qs';

const paymentAdminModule = namespace('paymentAdmin');

@Component({
  name: 'Callbacks',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
    CreateCallbackDialog: loadView('pages/payments/dialogs/CreateCallbackDialog'),
  },
  filters: { timestamp },
})
export default class Callbacks extends mixins(WidgetMixins, DialogMixins) {
  @paymentAdminModule.Getter('getCallbacks') callbacks!: IPaymentCallback[];
  @paymentAdminModule.Getter('getCallbacksPagination') pagination!: IPaginate;
  @paymentAdminModule.Getter('getMerchants') merchants!: IMerchants[];

  options: any = {};
  query: string = '';

  headers: Array<{ text: string; value: string; align?: string; sortable?: boolean }> = [
    { text: 'App', value: 'appName' },
    { text: 'Callback ID', value: '_id', sortable: false },
    { text: 'URL', value: 'callbackUrl', sortable: false },
    { text: 'Merchant', value: 'credentialId' },
    { text: 'Status', value: 'callbackStatus' },
    { text: 'Created', value: 'createdAt' },
  ];

  // credentialId comes back either populated or as a bare id.
  merchantName(callback: IPaymentCallback): string {
    const credential = callback.credentialId as any;
    if (credential && typeof credential === 'object') return credential.username ?? '—';
    return this.merchants.find(({ _id }) => _id === credential)?.username ?? '—';
  }

  copy(value: string, label: string): void {
    navigator.clipboard?.writeText(value).then(() => {
      this.$store.dispatch('snackBarMessage', `${label} copied to clipboard`, { root: true });
      this.$store.dispatch('snackBarVisibility', true, { root: true });
    });
  }

  handleSave(body: ICallbackBody): void {
    this.$store.dispatch('paymentAdmin/createCallback', { body, query: this.query });
  }

  fetchCallbacks(): void {
    this.$store.dispatch('paymentAdmin/fetchCallbacks', this.query);
  }

  @Watch('options', { deep: true })
  onOptionsChange(paginate: IPaginate): void {
    const query = qs.stringify(
      { page: paginate.page, size: paginate.itemsPerPage },
      { skipNulls: true, addQueryPrefix: true },
    );
    if (query === this.query) return;
    this.query = query;
    this.fetchCallbacks();
  }

  created(): void {
    // merchants populate the dialog picker and resolve names in the table
    this.$store.dispatch('paymentAdmin/fetchMerchants', '?isPaginated=false');
    this.query = qs.stringify({ page: 1, size: 30 }, { addQueryPrefix: true });
    this.fetchCallbacks();
  }
}
